(function () {
  'use strict';
  function init() {
    var dialog=document.querySelector('[data-search-drawer]');
    if (!dialog || dialog.dataset.bound) return;
    dialog.dataset.bound='true';
    var input=dialog.querySelector('[data-search-input]'),clear=dialog.querySelector('[data-search-clear]');
    var initial=dialog.querySelector('[data-search-initial]'),content=dialog.querySelector('[data-search-content]');
    var results=dialog.querySelector('[data-search-results]'),status=dialog.querySelector('[data-search-status]'),all=dialog.querySelector('[data-search-all]');
    var opener,overflow='',timer,closeTimer,controller,serial=0;
    function close() {
      dialog.classList.remove('is-open');
      clearTimeout(closeTimer);
      closeTimer=setTimeout(function(){dialog.close();document.body.style.overflow=overflow;if(opener)opener.focus();},matchMedia('(prefers-reduced-motion:reduce)').matches?0:800);
    }
    document.addEventListener('click',function(event){
      var trigger=event.target.closest('[data-search-open]');if(!trigger)return;
      event.preventDefault();opener=trigger;clearTimeout(closeTimer);overflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();
      requestAnimationFrame(function(){dialog.classList.add('is-open');input.focus();});
    });
    dialog.querySelector('[data-search-close]').addEventListener('click',close);
    dialog.addEventListener('cancel',function(event){event.preventDefault();close();});
    dialog.addEventListener('click',function(event){if(event.target===dialog){var r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right)close();}});
    function search() {
      clearTimeout(timer);if(controller)controller.abort();var request=++serial;var query=input.value.trim();
      clear.hidden=!query;initial.hidden=!!query;content.hidden=!query;results.replaceChildren();status.textContent='';
      all.href='/collections/shop?search='+encodeURIComponent(query);if(!query)return;
      status.textContent='Searching...';results.setAttribute('aria-busy','true');
      timer=setTimeout(async function(){
        controller=new AbortController();
        try {
          var url=new URL('/search',location.origin);url.searchParams.set('q',query);url.searchParams.set('type','product');url.searchParams.set('section_id','search-products');
          var response=await fetch(url,{signal:controller.signal});if(!response.ok)throw new Error('Search unavailable');
          var documentResult=new DOMParser().parseFromString(await response.text(),'text/html');
          var source=documentResult.querySelector('[data-search-response]');if(!source)throw new Error('Search unavailable');if(request!==serial)return;
          results.replaceChildren.apply(results,Array.from(source.querySelectorAll('.search-product')));
          status.textContent=results.children.length?'':'No products found. Try another search term or explore our latest collection.';
        } catch(error) {if(error.name!=='AbortError'&&request===serial)status.textContent='Search is temporarily unavailable. Try again or view the collection.';}
        finally {if(request===serial)results.removeAttribute('aria-busy');}
      },200);
    }
    input.addEventListener('input',search);clear.addEventListener('click',function(){input.value='';search();input.focus();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
